import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { cardsDataQueryKey } from 'api/queries/cardsData.query';
import { listCardsDataQueryKey } from 'api/queries/getListFilteredCards.query';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { AddTaskWrapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/AddTaskWrapper/AddTaskWrapper';
import { ColumnsBoardWrapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/ColumnsBoard/ColumnsBoardWrapper';
import { FiltersWrapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/FiltersWrapper/FiltersWrapper';
import { RowsBoard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/RowsBoard/RowsBoard';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { Button, TreeProgramTopHeader } from 'components/common';

export const ProjectActivitiesPage = () => {
    useFullStoryPageView({ pageName: executionConfig.battlecards.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader versionSelectorEnabled={true}>
                            <ShareInsightButton
                                title={executionConfig.battlecards.title}
                                link={window.location.href}
                                customTriggerElement={
                                    <Button variant={'secondary'} circle>
                                        <MuiIcon icon={'share'} />
                                    </Button>
                                }
                            />
                            <AddTaskWrapper />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.battlecards.title} />
                    <FiltersWrapper />
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ColumnsBoardWrapper />
                    <RowsBoard />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={[cardsDataQueryKey, listCardsDataQueryKey, 'CountersData', 'boardInit']} />
        </PageContainer>
    );
};
